import { jsx as _jsx } from "react/jsx-runtime";
import { ConsentServiceProvider, useConsentService } from "@aviv-csnt/react";
const DATADOG_CONSENT_ID = "Xl0HIOViY";
/**
 * Facade in front of "@aviv-csnt/react" to handle a possible double implementation for the UserCentrics v3 migration
 */
export const createConsentContext = (id) => ({
    Provider: ({ children }) => (_jsx(ConsentServiceProvider, { id: id, children: children })),
    useUserConsent,
});
export const useConsentServiceStatus = (id) => {
    const consentService = useConsentService();
    if (!id)
        return false;
    return Boolean(consentService.consentItems[id]?.consent);
};
export function createConsentServiceHook(consentID) {
    return () => {
        const consentService = useConsentService();
        const consentItem = consentService.consentItems[consentID];
        if (!consentService.isConsentGranted) {
            return;
        }
        return consentItem?.consent;
    };
}
export const useUserConsent = () => useConsentService().isConsentGranted;
export const useDatadogConsent = () => useConsentServiceStatus(DATADOG_CONSENT_ID);
